import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/HomePage.module.css";
import { ROUTES } from "../../config/routes";

export default function CTASection() {
    return (
        <section className={styles.cta}>
            <h2 className={styles.ctaTitle}>Stop Wondering. Start Hearing.</h2>
            <p className={styles.ctaSubtitle}>
                Join musicians who can finally hear what they're playing and play what they hear
            </p>
            <Link to={ROUTES.DRILL.INTERVALS} className={styles.ctaButton}>
                Begin Your First Exercise
            </Link>
        </section>
    );
}
